import { Component, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
    selector: 'cmps-scorecard-layout-container',
    template: ` <ng-container #ref></ng-container>`,
})
export class ScLayoutContainerComponent {
    @ViewChild('ref', { read: ViewContainerRef, static: true })
    viewContainerRef: ViewContainerRef;
}
